<template>
  <div no-body class="lku-arinvrealisasi">
    <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color: blue">Loading data ...</span></b-row>
    <b-row v-else>
      <b-col lg="6">
        <b-form-row>
          <b-col md="5">
            <b-input-group>
              <b-input-group-prepend><span class="mt-2">Filter &nbsp;</span></b-input-group-prepend>
              <b-form-input v-model="tblData.nomor" @keyup.13.native="refresh()" placeholder="Invoice Number"></b-form-input>
            </b-input-group>
          </b-col>
          <b-col md="7"><b-form-input v-model="tblData.uraian" @keyup.13.native="refresh()" placeholder="Description"></b-form-input></b-col>
        </b-form-row>
      </b-col>
      <b-col lg="6">
        <b-input-group>
          <b-input-group-prepend><span class="mt-2">Customer &nbsp;</span></b-input-group-prepend>
          <b-form-input v-model="tblData.customer" placeholder="customer" :disabled="(customer || '') !== ''" @keyup.13.native="refresh()"></b-form-input>
          <b-input-group-append>
            <b-button class="btn btn-success ml-1" @click="refresh()"> <i class="fa fa-refresh"></i>Filter</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>
    <b-table
      class="mb-0"
      ref="tblArinvOst"
      style="font-size: smaller"
      responsive
      small
      striped
      hover
      :items="data"
      :fields="fields"
      :current-page="tblData.page"
      :per-page="tblData.limit"
      :sort-by.sync="tblData.sortBy"
      :sort-desc.sync="tblData.sortDesc"
      :key="tblData.limit"
      @row-clicked="selectItem"
    >
      <template v-slot:cell(ttlamtdue)="data">
        {{ data.item.ttlamtdue | numFormat }}
      </template>

      <template v-slot:cell(realisasi)="data">
        {{ data.item.realisasi | numFormat }}
      </template>
    </b-table>
    <b-row>
      <b-col cols="4">
        <div class="pt-2">
          Showing {{ (tblData.page - 1) * tblData.limit + 1 }} to <span v-if="tblData.page * tblData.limit > tblData.total">{{ tblData.total }}</span>
          <span v-else>{{ tblData.page * tblData.limit }}</span> of {{ tblData.total }} entries
        </div>
      </b-col>
      <b-col cols="3">
        <b-row class="ml-2 mt-2">
          <span class="pt-1 pr-2">Limit per page</span>
          <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit" size="sm" style="width: 80px !important" />
        </b-row>
      </b-col>
      <b-col cols="5">
        <b-pagination align="right" :total-rows="tblData.total" :per-page="tblData.limit" v-model="tblData.page"></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>
<style lang="scss">
.lku-arinvrealisasi {
  td {
    padding: 0;

    a {
      //   border: 1px solid;
      text-decoration: none;
      display: block;
      padding: 0.5rem 0.75rem;
    }
  }
}
</style>

<script>
import arinvrealisasi from "../../apis/arinvrealisasi";

export default {
  data() {
    return {
      lkuLoading: false,
      fields: [
        {
          key: "invoiceno",
          thStyle: "width:150px",
          label: "Invoice Number",
          sortable: true,
        },
        {
          key: "uraian",
          label: "Description",
          sortable: true,
        },
        {
          key: "matauang",
          thStyle: "width:40px",
          label: "$,¥",
          sortable: true,
        },
        {
          key: "ttlamtdue",
          label: "Amount (Deffered)",
          thStyle: "width:100px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "realisasi",
          label: "Realization",
          thStyle: "width:100px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true,
        },
      ],
      tblData: {
        page: 1,
        limit: 20,
        total: 0,
        sortBy: "invdate",
        sortDesc: true,
        customer: "",
        invmanual: "1",
        outstand: "1",
      },
    };
  },
  computed: {
    filterCustomer() {
      return this.tblData.customer;
    },
  },
  watch: {
    filterCustomer: function (newval) {
      this.$emit("update:customer", newval);
      // console.log('prop Customer : ',this.customer);
      // console.log('prop tbldata.Customer : ',newval);
    },
  },
  props: ["customer"],
  created: async function () {
    this.tblData.customer = this.customer;
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function (ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      // this.tblData.customer=this.customer;
      this.lkuLoading = true;
      const list = await arinvrealisasi.listdeffered(this.tblData);
      this.lkuLoading = false;
      return list;
    },
    selectItem(item, index) {
      // 'item' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$emit("click", item);
    },
    clearFilter() {
      this.tblData = { nomor: "", uraian: "" };
      this.refresh();
    },
    keymonitor: function (event) {
      console.log(event.key);
      if (event.key == "Enter") {
        //  console.log('the id of the input was:' + event.currentTarget.id);
        this.$refs.tblArinvOst.refresh();
      }
    },
    refresh() {
      this.$refs.tblArinvOst.refresh();
    },
  },
};
</script>
